module.exports = __webpack_public_path__ + "assets/images/profiles/2020s.png?v=a4f1cbdc";